import {
    combineReducers
} from 'redux';

import appReducer from './app/appReducer';
import entitiesReducer from './entities/entitiesReducer';
import uiReducer from './ui/uiReducer';
import compareReducer from './compare/compareReducer';
import sessionReducer from './session/sessionReducer';
import inlineReducer from './inline/inlineReducer';

const RootReducer = combineReducers({
    app:appReducer,
    entities: entitiesReducer,
    ui: uiReducer,
    compare: compareReducer,
    session: sessionReducer,
    inline: inlineReducer,
});

export default RootReducer;